<template>
  <div>
    <a
      style="display: flex"
      href="javascript:;"
      class="name-btn"
      @click="runFilter()"
      ><i class="ag-icon ag-icon_darkSearch" style="margin: 3px 9px 0 0"></i>
      {{ $t("runfilter") }}
    </a>
  </div>
</template>

<script>
export default {
  name: "runSavedFilter",
  props: {
    data: {
      type: Array,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  methods: {
    runFilter() {
      let data = this.data.filterJsonData;
      const filterType = this.$route.params.param;
      // eslint-disable-next-line no-debugger
      // debugger;
      const routes = {
        hashPageFilter: {
          name: "threat", //use name for router push
          params: { param: "allhashes", data },
        },
        eventPageFilter: {
          name: "eventInspection", //use name for router push
          params: { param: "all-events", data },
        },
      };
      if (routes[filterType]) this.$router.push(routes[filterType]);
    },
  },
};
</script>
